import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingCheckInSync
} from "app/services/VisitService";
import { syncListCheckInToCrm } from "app/services/SyncCRMService";

export default class CheckInAsyncStore {
  searchCheckIn = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    listDepId: null,
    isSyncedToCRM: false,
  };
  selectCheckInAsync = [];
  resetSelectedRows = false;
  pageCheckIn = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingCheckIn = async () => {
    const { listDepId, visitTypeCode, ...ortherData } = this.searchCheckIn;
    if (visitTypeCode) {
      ortherData.visitTypeCode = visitTypeCode?.code;
    }
    if (listDepId) {
      ortherData.listDepId = listDepId?.map(el => el?.id);
    }
    return await pagingCheckInSync({ ...ortherData })
      .then(({ data }) => {
        this.pageCheckIn = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu Checkin có lỗi");
      });
  };

  handleChangeFormSearch = (searchCheckIn) => {
    this.searchCheckIn = { ...this.searchCheckIn, ...searchCheckIn };

    this.pagingCheckIn();
  };

  setSelectCheckInAsync = (list) => {
    this.selectCheckInAsync = list;
  };

  syncListCheckInToCrm = async () => {
    const patientIds = this.selectCheckInAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;
    return await syncListCheckInToCrm(patientIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectCheckInAsync = [];
        if (data) {
          toast.success("Đồng bộ Check In thành công");
          this.pagingCheckIn();
        } else {
          toast.error("Đồng bộ Check In có lỗi");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectCheckInAsync = [];
        console.error(error);
        toast.error("Đồng bộ Check In có lỗi");
      });
  };

  resetStore = () => {
    this.searchCheckIn = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      listDepId: null,
      isSyncedToCRM: false,
    };
  };
}
